import { UserManagement } from '@/components/UserManagement';

const AdminUsers = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <UserManagement />
    </div>
  );
};

export default AdminUsers;